import React from 'react';

import { Button } from '@qality/common-components/src/atoms/Button';
import { ProjectSelect } from '@qality/common-components/src/molecules/final-form/ProjectSelect';
import { Select as SelectField } from '@qality/common-components/src/molecules/final-form/Select';
import { TextField } from '@qality/common-components/src/molecules/final-form/TextField';
import { FEATURE_FLAG } from '@qality/common-config';

import {
  TestCyclesOverviewFiltersColumnStyled,
  TestCyclesOverviewFiltersStyled,
  TestCyclesOverviewProjectSelectStyled,
} from './TestCyclesOverviewFilters.styled';

export interface TestCyclesOverviewFiltersViewProps {
  handleSearchTestCycles: () => void;
  handleOpenDialog: () => void;
  isLoading: boolean;
  isFetchingProjectVersion: boolean;
  projectVersionList: { name: string; id: string; projectId: string }[];
  isProjectSelected: boolean;
  stateOptions: { label: string; value: boolean | null }[];
}

export const TestCyclesOverviewFiltersView: React.FC<TestCyclesOverviewFiltersViewProps> =
  ({
    handleSearchTestCycles,
    handleOpenDialog,
    isLoading,
    isFetchingProjectVersion,
    projectVersionList,
    isProjectSelected,
    stateOptions,
  }: TestCyclesOverviewFiltersViewProps) => {
    return (
      <TestCyclesOverviewFiltersStyled>
        <TestCyclesOverviewFiltersColumnStyled fillContainer size='medium'>
          <TestCyclesOverviewProjectSelectStyled>
            <ProjectSelect
              name='project'
              isClearable
              placeholder='All Projects'
              useAllOption={false}
            />
          </TestCyclesOverviewProjectSelectStyled>
        </TestCyclesOverviewFiltersColumnStyled>

        <TestCyclesOverviewFiltersColumnStyled fillContainer size='medium'>
          <SelectField
            name='version'
            isDisabled={!isProjectSelected || isFetchingProjectVersion}
            isClearable
            options={
              !isProjectSelected
                ? []
                : projectVersionList?.map((p) => ({
                    label: `${p.name}`,
                    value: p.id,
                    versionId: p.id,
                    projectId: p.projectId,
                  }))
            }
            placeholder='Search version..'
          />
        </TestCyclesOverviewFiltersColumnStyled>
        {FEATURE_FLAG.isPremium && (
          <TestCyclesOverviewFiltersColumnStyled fillContainer size='medium'>
            <SelectField
              name='state'
              options={stateOptions}
              placeholder='Select State..'
            />
          </TestCyclesOverviewFiltersColumnStyled>
        )}

        <TestCyclesOverviewFiltersColumnStyled fillContainer size='small'>
          <TextField name='searchText' placeholder='Contains text..' />
        </TestCyclesOverviewFiltersColumnStyled>

        <TestCyclesOverviewFiltersColumnStyled>
          <Button
            isDisabled={isLoading}
            onClick={handleSearchTestCycles}
            appearance='default'
          >
            Filter
          </Button>
        </TestCyclesOverviewFiltersColumnStyled>
        <TestCyclesOverviewFiltersColumnStyled fillContainer />
        <TestCyclesOverviewFiltersColumnStyled>
          <Button onClick={handleOpenDialog} appearance='primary'>
            Create test cycle
          </Button>
        </TestCyclesOverviewFiltersColumnStyled>
      </TestCyclesOverviewFiltersStyled>
    );
  };
